fragment SupplierControlPanelGeneralProfitFragment on SupplierControlPanelGeneralProfit {
    id
    supplier_id
    supplier_name
    supplier_quantities
    print_start_cost_profit
    handling_charge_profit
    profit_by_quantity
}